import { ca } from '@cian/analytics';

import { IOfferSnippetSchema } from 'shared/repositories/commercial-search-offers/entities/offer_snippet/OfferSnippetSchema';

import { SPECIAL_PROJECT_CAROUSEL_OPTIONS } from '../constants';
import { getSpecialProjectOffersPositions } from '../utils/getSpecialProjectOffersPositions';

export function trackSlideChange({
  realtyUserId,
  offers,
  activeSlideIndex,
  title,
  builderCardUrl,
}: {
  realtyUserId: number;
  activeSlideIndex: number;
  offers: IOfferSnippetSchema[];
  title: string;
  builderCardUrl: string;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_scroll',
    page: {
      extra: {
        is_specproject: true,
        content: getSpecialProjectOffersPositions({
          step: SPECIAL_PROJECT_CAROUSEL_OPTIONS.slidesPerView,
          activeSlideIndex,
          offers,
        }),
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
